import React from "react";
import styled from "styled-components";

// Styled Components
const SwitchWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 45px;
  height: 22px;
`;

const SwitchLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 15px;
  cursor: pointer;
  background-color: ${(props) => (props.isOn ? "#EE754C" : "#c2c0c0")};
  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: ${(props) => (props.isOn ? "22px" : "3px")};
    width: 18px;
    height: 18px;
    background-color: white;
    border-radius: 50%;
    transition: 0.2s;
  }
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

// Component
const SwitchOnAndOff = ({ isOn, handleToggle, id }) => {
  // Generate a unique ID if none is provided
  const uniqueId = id || `switch-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <SwitchWrapper>
      <SwitchInput
        id={uniqueId}
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
      />
      <SwitchLabel htmlFor={uniqueId} isOn={isOn} />
    </SwitchWrapper>
  );
};

export default SwitchOnAndOff;
